import {
  ArrowLeftOutlined,
  CheckOutlined,
  ReloadOutlined,
} from '@ant-design/icons'
import { Button, Form, Input } from 'antd'
import { AxiosError, isAxiosError } from 'axios'
import { t } from 'i18next'
import { useState } from 'react'
import { Spacer } from '../../../components'
import { httpErrorStatus } from '../../../constants/constants'
import { authService, notificationService } from '../../../services'
import { ForgotPasswordStepsFooter, FormLayout } from '../ForgotPasswordPage'
import styled from 'styled-components'

const MainLabelContainer = styled.div`
  margin-bottom: 24px;
  font-weight: 600;
  font-size: 12px;
`
interface FormValues {
  pin: string
}

interface ForgotPasswordStep2Props {
  onNext: (pin: string) => void
  onCancel: () => void
  onResend: (token: string) => void
  email: string
  inviteToken: string
  onCodeError: () => void
}

const ForgotPasswordStep2Code = ({
  onNext,
  onCancel,
  email,
  onResend,
  inviteToken,
  onCodeError,
}: ForgotPasswordStep2Props) => {
  const [loading, setLoading] = useState(false)

  const handleResendPassword = async () => {
    setLoading(true)
    await authService.forgotPasswordInvite(email).then(
      (response: any) => {
        notificationService.notificationSuccess({
          messageToDisplay: t('forgotPasswordPage.step2Code.successResendPin'),
        })
        setLoading(false)
        onResend(response.inviteToken)
      },
      (error) => {
        console.error('Login error', error)
        setLoading(false)
        onCodeError()
      }
    )
  }

  const handleSubmit = async (values: FormValues) => {
    setLoading(true)
    await authService.forgotPasswordValidatePin(inviteToken, values.pin).then(
      (response: any) => {
        setLoading(false)
        onNext(values.pin)
      },
      (error: AxiosError | Error) => {
        console.error('Login error', error)
        setLoading(false)
        if (
          isAxiosError(error) &&
          error.response?.status === httpErrorStatus.ERROR_403_FORBIDDEN
        ) {
          onCodeError()
        }
      }
    )
  }

  return (
    <Form onFinish={handleSubmit} layout="vertical">
      <FormLayout>
        <div>
          <MainLabelContainer>
            {t('forgotPasswordPage.step2Code.introduction')}
          </MainLabelContainer>
          <Form.Item
            label={t('forgotPasswordPage.step2Code.codeLabel')}
            name="pin"
            extra={t('forgotPasswordPage.step2Code.helper')}
            rules={[{ required: true, message: t('otpInput.required') }]}
          >
            <Input.OTP
              length={6}
              size="large"
              disabled={loading}
              style={{ gap: 8 }}
            />
          </Form.Item>
        </div>

        <ForgotPasswordStepsFooter>
          <Spacer />
          <Button
            onClick={onCancel}
            icon={<ArrowLeftOutlined />}
            type="default"
          >
            {t('forgotPasswordPage.stepsCancelButton')}
          </Button>
          <Button
            onClick={handleResendPassword}
            icon={<ReloadOutlined />}
            type="text"
          >
            {t('forgotPasswordPage.step2Code.resendPinButton')}
          </Button>
          <Button type="primary" htmlType="submit" icon={<CheckOutlined />}>
            {t('forgotPasswordPage.step2Code.okButton')}
          </Button>
        </ForgotPasswordStepsFooter>
      </FormLayout>
    </Form>
  )
}

export default ForgotPasswordStep2Code
